import React from "react";
import { useNavigate } from "react-router";
import { StyckeCompact } from "./ContentStyles";
import Rules from "./Rules";
import { Branding } from "../services/misc";
import "./PricePage.scss";
import { BsLightning } from "react-icons/bs";
import { FaStore } from "react-icons/fa";
import { IoWifi } from "react-icons/io5";
import { IoCartOutline } from "react-icons/io5";
import { GiReceiveMoney } from "react-icons/gi";
import { FaMobileAlt } from "react-icons/fa";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const PricePage = () => {
    const navigate = useNavigate();

    function handleSubmitProd(defaultproduct) {
        navigate("/signup?defaultproduct=" + defaultproduct);
    }

    const brandName =
        window.location.origin === "https://www.xn--nrbutik-5wa.se"
            ? "Närbutik.se"
            : "Nookshop";

    const plans = [
        {
            key: "NS1",
            title: "Kylskåp 250L",
            price: "1295:-",
            period: "/månad",
            details: [
                { label: "Bindningstid", value: "36 månader" },
                { label: "Startkostnad", value: "0:-" },
                { label: "Månadskostnad", value: "1295:-" },
                { label: "Antal varor", value: "25" },
                { label: "Antal produktgrupper", value: "5" },
                { label: "Uppkoppling", value: "WiFi" },
                { label: "Transaktionskostnad", value: "0.20:-/köp" },
                { label: "Applikationsexempel", value: "Tex: Lunch, dryck, snacks mm", isExample: true },
            ],
            featured: false,
        },
        {
            key: "NS2",
            title: "Butik micro",
            price: "495:-",
            period: "/månad",
            details: [
                { label: "Bindningstid", value: "24 månader" },
                { label: "Startkostnad", value: "0:-" },
                { label: "Månadskostnad", value: "495:-" },
                { label: "Antal varor", value: "5" },
                { label: "Antal produktgrupper", value: "1" },
                { label: "Uppkoppling", value: "WiFi" },
                { label: "Transaktionskostnad", value: "0.20:-/köp" },
                { label: "Applikationsexempel", value: "Tex: Honung, äggförsäljning", isExample: true },
            ],
            featured: false,
        },
        {
            key: "NS3",
            title: "Butik standard",
            price: "1495:-",
            period: "/månad",
            details: [
                { label: "Bindningstid", value: "24 månader" },
                { label: "Startkostnad", value: "0:-" },
                { label: "Månadskostnad", value: "1495:-" },
                { label: "Antal varor", value: "50" },
                { label: "Antal produktgrupper", value: "5" },
                { label: "Uppkoppling", value: "WiFi" },
                { label: "Transaktionskostnad", value: "0.20:-/köp" },
                { label: "Applikationsexempel", value: "Tex: Gårdsbutik, 9-Hålet", isExample: true },
            ],
            featured: true,
        },
        {
            key: "NS4",
            title: "Butik large",
            price: "2495:-",
            period: "/månad",
            details: [
                { label: "Bindningstid", value: "24 månader" },
                { label: "Startkostnad", value: "0:-" },
                { label: "Månadskostnad", value: "2495:-" },
                { label: "Antal varor", value: "200" },
                { label: "Antal produktgrupper", value: "20" },
                { label: "Uppkoppling", value: "WiFi" },
                { label: "Transaktionskostnad", value: "0.20:-/köp" },
                { label: "Applikationsexempel", value: "Tex: Gårdsbutik, Kiosk, Närbutik", isExample: true },
            ],
            featured: false,
        },
    ];

    return (
        <>
            <Helmet>
                <title>{brandName} | Priser och abonnemang för obemannad butik</title>
                <meta
                    name="description"
                    content="Se priser och abonnemang för obemannad butik. Jämför kylskåp, micro, standard och large och välj paketet som passar din verksamhet bäst."
                />
            </Helmet>
            <div className="pricing-page">
                {/* HERO */}
                <section className="pricing-hero" aria-labelledby="pricing-page-title">
                    <div className="pricing-hero__inner">
                        <div className="pricing-pill">
                            <span className="pricing-pill__icon"><BsLightning aria-hidden="true" /></span>
                            <span className="pricing-pill__text">Våra abonnemang</span>
                        </div>

                        <h1 id="pricing-page-title" className="pricing-title">
                            Välj det <span className="pricing-title__accent">paket </span>som passar dina behov
                        </h1>

                        <p className="pricing-subtitle">
                            Jämför abonnemang för obemannad butik – från mindre kylskåpslösningar till kompletta butikssystem för gårdsbutik, kiosk eller närbutik.
                        </p>
                    </div>
                </section>

                {/* CARDS */}
                <section className="pricing-cards" aria-labelledby="pricing-packages-title">
                    <p className="pricing-cards__intro">
                        Här kan du jämföra våra olika abonnemang för obemannad butik och välja den lösning som passar din verksamhet bäst.
                    </p>
                    <div className="pricing-cards__grid">
                        {plans.map((p) => (
                            <article
                                key={p.key}
                                className={`pricing-card ${p.featured ? "pricing-card--featured" : ""}`}
                                aria-labelledby={`plan-title-${p.key}`}
                            >
                                {p.featured && (
                                    <div className="pricing-card__badge">Mest populär</div>
                                )}

                                <h3 id={`plan-title-${p.key}`} className="pricing-card__title">{p.title}</h3>

                                <div className="pricing-card__priceRow">
                                    <div className="pricing-card__price">{p.price}</div>
                                    <div className="pricing-card__period">{p.period}</div>
                                </div>

                                <div className="pricing-card__details" role="list">
                                    {p.details.map((d, idx) => (
                                        <div
                                            key={idx}
                                            className={`pricing-row ${d.isExample ? "pricing-row--example" : ""}`}
                                            role="listitem"
                                        >
                                            <div className="pricing-row__label">{d.label}</div>
                                            <div className="pricing-row__value">{d.value}</div>
                                        </div>
                                    ))}
                                </div>

                                <button
                                    className="pricing-card__cta"
                                    style={
                                        p.featured
                                            ? { backgroundColor: "#fff", color: "#ff8800" }
                                            : { backgroundColor: "#ff8800", color: "#fff" }
                                    }
                                    onClick={() => handleSubmitProd(p.key)}
                                    type="button"
                                    aria-label={`Välj paketet ${p.title}`}
                                >
                                    Starta med detta paket <span className="pricing-card__arrow">→</span>
                                </button>
                            </article>
                        ))}
                    </div>

                    <div className="pricing-note">
                        <StyckeCompact>
                            För att en fysisk butik ska fungera behövs ett elektriskt lås. En lokal låssmed kan hjälpa dig med installationen.
                            <br />
                            Fakturering sker i förväg, tre månader i taget. Uppsägning av tjänsten ska ske innan en ny tremånadersperiod påbörjas.
                            <Rules />
                        </StyckeCompact>
                    </div>
                    <p className="pricing-more">
                        Är du osäker på vilket paket som passar? Läs mer om <Link to="/starta">hur du startar din butik</Link> eller <Link to="/contact">kontakta oss</Link>.
                    </p>
                </section>

                {/* INCLUDED */}
                <section className="pricing-includes" aria-labelledby="pricing-includes-title">
                    <h2 id="pricing-includes-title" className="pricing-includes__title">Alla paket inkluderar</h2>

                    <div className="pricing-includes__grid">
                        <div className="include">
                            <div className="include__icon"><FaStore aria-hidden="true" /></div>
                            <div className="include__head">Komplett system</div>
                            <div className="include__text">Allt du behöver för att driva din obemannade butik</div>
                        </div>

                        <div className="include">
                            <div className="include__icon"><GiReceiveMoney aria-hidden="true" /></div>
                            <div className="include__head">Startkostnad</div>
                            <div className="include__text">Startkostnad är alltid 0:-</div>
                        </div>

                        <div className="include">
                            <div className="include__icon"><IoWifi aria-hidden="true" /></div>
                            <div className="include__head">Online</div>
                            <div className="include__text">Alltid online 24/7</div>
                        </div>

                        <div className="include">
                            <div className="include__icon"><FaMobileAlt aria-hidden="true" /></div>
                            <div className="include__head">Mobil app</div>
                            <div className="include__text">För kunder att handla med BankID och Swish</div>
                        </div>
                    </div>
                </section>

            </div>
        </>
    );
};

export default PricePage;
